import { SET_USER } from "../actions/userActions";
const initial = { access_token: "", email: "", name: "", token_type: "bearer" };
export default function (state = initial, action) {
  if (action.type === SET_USER) {
    let newState;
    const { name, email } = action.payload.user;
    newState = {
      name: name,
      email: email,
    };
    console.log("setuser", state);
    return newState;
  }
  console.log("userReducer", state);

  return state;
}
